/**
 * Для страницы `/mail/{id}`
 *
 * @param {{partsCount, COMPOSITE}} options
 */
var mailApp = function(options) {
    // 1. Setup
    var self = this,
        $document = $(document),
        $partsList = $('#parts-list'),
        partsCount = options.partsCount,
        $templateChoice = $('#mailjet_template'),
        $tab = $('.tab-mail-composite');

    var classes = {
        HEADING: 'part-visible-h',
        PARAGRAPH: 'part-visible-p',
        IMAGE: 'part-visible-img',
        IMAGE_LINK: 'part-visible-img-link',
        BUTTON: 'part-visible-btn'
    };

    /**
     * Скрывает/показывает пля ввода для составного/остальных типов
     */
    this.updateMailContent = function() {
        if ($templateChoice.val() == options.COMPOSITE) {
            $tab.removeClass('hidden').siblings('.tab-mail').addClass('hidden');
        } else {
            $tab.addClass('hidden').siblings('.tab-mail').removeClass('hidden');
        }
    };

    /**
     * Скрывает ненужные и показывает нужные поля ввода для части составного шаблона, в зависимости от типа
     *
     * @param {jQuery} $container
     */
    this.toggleTemplateParts = function($container) {
        $container.each(function(i, container) {
            var type = $(container).find('div.template-part-type select').val();

            if (!classes.hasOwnProperty(type)) {
                return;
            }

            $(container).find('.template-part').each(function(i, part) {
                var visible = $(part).hasClass(classes[type]);

                $(part).toggle(visible);
            });
        });
    };

    /**
     * Навешивает tinymce на все элементы с классом `textarea-tinymce-template-part`
     */
    this.initializePartRichEditor = function() {
        tinymce.init({
            selector: ".textarea-tinymce-template-part",
            theme: "modern",
            plugins: [
                "autolink link paste"
            ],
            menu: {},
            setup: function (editor) {
                editor.on('NodeChange', function () {
                    $(editor.getBody()).find('a').attr('style', 'color: #1086e0');
                });
            },
            toolbar: "link | alignleft aligncenter alignright alignjustify"
        });
    };

    // 2. События
    $document.on('click', 'a.action-add-part', function(e) {
        e.preventDefault();

        var part = $partsList.data('prototype').replace(/__name__/g, partsCount),
            $part = $(part);

        partsCount++;

        $part.appendTo($partsList);
        self.toggleTemplateParts($part);
        self.initializePartRichEditor();
    });

    $document.on('click', 'a.action-remove-part', function(e) {
        e.preventDefault();

        $(this).closest('div.part-container').remove();
    });

    $templateChoice.change(function() {
        self.updateMailContent();
    });

    $document.on('change', 'div.template-part-type select', function() {
        self.toggleTemplateParts($(this).closest('div.part-container'));
    });

    // 3. Запуск
    // Текст письма для "не-составных" шаблонов
    tinymce.init({
        selector: ".textarea-tinymce",
        theme: "modern",
        theme_modern_font_sizes: ["6px,7px,8px,9px,10px,11px,12px,13px,14px,15px,16px,17px,18px,19px,20px,21px,22px,23px,24px,25px,26px,27px,28px,29px,30px,31px,32px,36px,38px,40px"],
        setup: function (ed) {
            ed.on('init', function () {
                this.getDoc().body.style.fontSize = '16px';
            });
        },
        plugins: [
            "advlist autolink lists link image charmap print preview hr anchor pagebreak",
            "searchreplace wordcount visualblocks visualchars code fullscreen",
            "insertdatetime media nonbreaking save table contextmenu directionality",
            "emoticons template paste textcolor colorpicker textpattern"
        ],
        toolbar1: "preview | link image forecolor backcolor | bold italic fontsizeselect | insertfile undo redo |" +
        "| alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | print"
    });

    setTimeout(function () {
        $('#test-email-result').hide();
    }, 15000);

    // Отобразить составной/не-составной
    self.updateMailContent();

    // Для всех частей составного: скрыть/показать поля
    self.toggleTemplateParts($tab.find('div.part-container'));

    // В составном везде сделать tinyMCE
    self.initializePartRichEditor();
};